import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCompassSquare: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="compass-square, browser, safari, web, internet, navigation"><path d="M15 9L10 10L9 15L14 14L15 9Z" stroke="currentColor" strokeWidth="1.5"/><path d="M3.75 3.75H20.25V20.25H3.75V3.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCompassSquare;
